import {
  FETCH_ANALYTICS_LOADING,
  FETCH_ANALYTICS_DONE,
  FETCH_ANALYTICS_ERROR,

  FETCH_CREDIT_LOADING,
  FETCH_CREDIT_DONE,
  FETCH_CREDIT_ERROR,

  FETCH_OVERDUE_INVOICE_LOADING,
  FETCH_OVERDUE_INVOICE_DONE,
  FETCH_OVERDUE_INVOICE_ERROR,

  FETCH_UPCOMING_INVOICE_LOADING,
  FETCH_UPCOMING_INVOICE_DONE,
  FETCH_UPCOMING_INVOICE_ERROR,

  FETCH_ROAD_MAP_LOADING,
  FETCH_ROAD_MAP_DONE,
  FETCH_ROAD_MAP_ERROR,

  FETCH_TIME_PERFORMANCE_LOADING,
  FETCH_TIME_PERFORMANCE_DONE,
  FETCH_TIME_PERFORMANCE_ERROR,

  FETCH_SAVINGS_LOADING,
  FETCH_SAVINGS_DONE,
  FETCH_SAVINGS_ERROR,

  FETCH_SPENDING_YTD_LOADING,
  FETCH_SPENDING_YTD_DONE,
  FETCH_SPENDING_YTD_ERROR,

  FETCH_TODO_LOADING,
  FETCH_TODO_DONE,
  FETCH_TODO_ERROR,

  FETCH_TODO_ALL_LOADING,
  FETCH_TODO_ALL_DONE,
  FETCH_TODO_ALL_ERROR,

  UPDATE_ISREAD_TODO_LOADING,
  UPDATE_ISREAD_TODO_DONE,
  UPDATE_ISREAD_TODO_ERROR,

  FETCH_NOTIFICATION_LOADING,
  FETCH_NOTIFICATION_DONE,
  FETCH_NOTIFICATION_ERROR,

  FETCH_NOTIFICATION_ALL_LOADING,
  FETCH_NOTIFICATION_ALL_DONE,
  FETCH_NOTIFICATION_ALL_ERROR,

  UPDATE_ISREAD_NOTIF_LOADING,
  UPDATE_ISREAD_NOTIF_DONE,
  UPDATE_ISREAD_NOTIF_ERROR,

  GET_ROADMAP_COUNTRY_DONE,
  GET_ROADMAP_COUNTRY_LOADING,
  GET_ROADMAP_COUNTRY_ERROR

} from './actions'

export default {
  [FETCH_ANALYTICS_LOADING] (state) {
    state.isLoadingAnalytics = true
  },
  [FETCH_ANALYTICS_DONE] (state, items) {
    state.itemAnalytics = items
    state.isLoadingAnalytics = false
    state.errorAnalytics = false
  },
  [FETCH_ANALYTICS_ERROR] (state, error) {
    state.errorAnalytics = error
    state.isLoadingAnalytics = true
  },

  [FETCH_CREDIT_LOADING] (state) {
    state.isLoadingGetCredit = true
  },
  [FETCH_CREDIT_DONE] (state, items) {
    state.getCredit = items
    state.isLoadingGetCredit = false
    state.errorGetCredit = false
  },
  [FETCH_CREDIT_ERROR] (state, error) {
    state.errorGetCredit = error
    state.isLoadingGetCredit = true
  },

  [FETCH_OVERDUE_INVOICE_LOADING] (state) {
    state.isLoadingItemOverdueInvoice = true
  },
  [FETCH_OVERDUE_INVOICE_DONE] (state, items) {
    state.itemOverdueInvoice = items
    state.isLoadingItemOverdueInvoice = false
  },
  [FETCH_OVERDUE_INVOICE_ERROR] (state, error) {
    state.errorItemOverdueInvoice = error
    state.isLoadingItemOverdueInvoice = false
  },

  [FETCH_UPCOMING_INVOICE_LOADING] (state) {
    state.isLoadingItemUpcomingInvoice = true
  },
  [FETCH_UPCOMING_INVOICE_DONE] (state, items) {
    state.itemUpcomingInvoice = items
    state.isLoadingItemUpcomingInvoice = false
  },
  [FETCH_UPCOMING_INVOICE_ERROR] (state, error) {
    state.errorItemUpcomingInvoice = error
    state.isLoadingItemUpcomingInvoice = false
  },

  [FETCH_ROAD_MAP_LOADING] (state) {
    state.isLoadingItemRoadMap = true
  },
  [FETCH_ROAD_MAP_DONE] (state, items) {
    state.itemRoadMap = items
    state.isLoadingItemRoadMap = false
  },
  [FETCH_ROAD_MAP_ERROR] (state, error) {
    state.errorItemRoadMap = error
    state.isLoadingItemRoadMap = false
  },

  [FETCH_TIME_PERFORMANCE_LOADING] (state) {
    state.isLoadingTimePerf = true
  },
  [FETCH_TIME_PERFORMANCE_DONE] (state, items) {
    state.itemTimePerf = items
    state.isLoadingTimePerf = false
  },
  [FETCH_TIME_PERFORMANCE_ERROR] (state, error) {
    state.errorTimePerf = error
    state.isLoadingTimePerf = false
  },

  [FETCH_SAVINGS_LOADING] (state) {
    state.isLoadingSavings = true
  },
  [FETCH_SAVINGS_DONE] (state, items) {
    state.itemSavings = items
    state.isLoadingSavings = false
  },
  [FETCH_SAVINGS_ERROR] (state, error) {
    state.errorSavings = error
    state.isLoadingSavings = false
  },

  [FETCH_SPENDING_YTD_LOADING] (state) {
    state.isLoadingSpendingYTD = true
  },
  [FETCH_SPENDING_YTD_DONE] (state, items) {
    state.itemSpendingYTD = items
    state.isLoadingSpendingYTD = false
  },
  [FETCH_SPENDING_YTD_ERROR] (state, error) {
    state.errorSpendingYTD = error
    state.isLoadingSpendingYTD = false
  },

  [FETCH_TODO_LOADING] (state) {
    state.isLoadingItemTodo = true
  },
  [FETCH_TODO_DONE] (state, items) {
    state.itemTodo = items
    state.isLoadingItemTodo = false
  },
  [FETCH_TODO_ERROR] (state, error) {
    state.errorItemTodo = error
    state.isLoadingItemTodo = false
  },

  [FETCH_TODO_ALL_LOADING] (state) {
    state.isLoadingItemTodoAll = true
  },
  [FETCH_TODO_ALL_DONE] (state, items) {
    state.itemTodoAll = items
    state.isLoadingItemTodoAll = false
  },
  [FETCH_TODO_ALL_ERROR] (state, error) {
    state.errorItemTodoAll = error
    state.isLoadingItemTodoAll = false
  },

  [UPDATE_ISREAD_TODO_LOADING] (state) {
    state.isLoadingUpdateIsReadTodo = true
  },
  [UPDATE_ISREAD_TODO_DONE] (state, items) {
    state.updateIsReadTodo = items
    state.isLoadingUpdateIsReadTodo = false
  },
  [UPDATE_ISREAD_TODO_ERROR] (state, error) {
    state.errorUpdateIsReadTodo = error
    state.isLoadingUpdateIsReadTodo = false
  },

  [FETCH_NOTIFICATION_LOADING] (state) {
    state.isLoadingItemNotif = true
  },
  [FETCH_NOTIFICATION_DONE] (state, items) {
    state.itemNotif = items
    state.isLoadingItemNotif = false
  },
  [FETCH_NOTIFICATION_ERROR] (state, error) {
    state.errorItemNotif = error
    state.isLoadingItemNotif = false
  },

  [FETCH_NOTIFICATION_ALL_LOADING] (state) {
    state.isLoadingItemNotifAll = true
  },
  [FETCH_NOTIFICATION_ALL_DONE] (state, items) {
    state.itemNotifAll = items
    state.isLoadingItemNotifAll = false
  },
  [FETCH_NOTIFICATION_ALL_ERROR] (state, error) {
    state.errorItemNotifAll = error
    state.isLoadingItemNotifAll = false
  },

  [UPDATE_ISREAD_NOTIF_LOADING] (state) {
    state.isLoadingUpdateIsReadNotif = true
  },
  [UPDATE_ISREAD_NOTIF_DONE] (state, items) {
    state.updateIsReadNotif = items
    state.isLoadingUpdateIsReadNotif = false
  },
  [UPDATE_ISREAD_NOTIF_ERROR] (state, error) {
    state.errorUpdateIsReadNotif = error
    state.isLoadingUpdateIsReadNotif = false
  },

  [GET_ROADMAP_COUNTRY_LOADING] (state) {
    state.isLoadingGetRoadmapCountry = true
  },
  [GET_ROADMAP_COUNTRY_DONE] (state, items) {
    state.getRoadmapCountry = items
    state.isLoadingGetRoadmapCountry = false
  },
  [GET_ROADMAP_COUNTRY_ERROR] (state, error) {
    state.errorGetRoadmapCountry = error
    state.isLoadingGetRoadmapCountry = false
  }

}



// WEBPACK FOOTER //
// ./src/store/modules/dashboard/mutations.js